import React__default from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-nxf96eG-.js';
import { S as StormContextProvider } from '../StormContext/StormContextProvider-BTxpbm54.js';
import { C as ConfigObserver } from './ConfigObserver-xpKlUycK.js';
import { u as useEffectiveTheme } from './hooks/useThemeMode/useEffectiveTheme-CRrOPNAG.js';

const ThemeProvider = ({
  children,
  theme,
  enableThemeModes = false
}) => {
  // Reactive theme that responds to user preference changes (light/dark/system)
  // Only computed when theme modes are enabled and no explicit theme is provided
  const dynamicTheme = useEffectiveTheme(enableThemeModes && !theme);

  // Final theme applied to styled-components context, resolved in priority order:
  // 1. Explicit theme prop (highest priority)
  // 2. Dynamic theme based on user preference (when theme modes enabled)
  // 3. Default light theme (fallback)
  const effectiveTheme = theme || (enableThemeModes ? dynamicTheme : stormLightTheme);
  return /*#__PURE__*/React__default.createElement(ConfigObserver, null, config => /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: effectiveTheme
  }, /*#__PURE__*/React__default.createElement(StormContextProvider, null, children)));
};

export { ThemeProvider as T };
//# sourceMappingURL=ThemeProvider-BFmLMLf7.js.map
